import { DataGrid, GridActionsCellItem, GridColumns } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IRBDItemRow } from "../../app/models/rbd";

function RBDSettingTable() {
    const { rbdStore, dialogStore } = useStore();

    const columns: GridColumns<IRBDItemRow> = [
        { field: 'no', headerName: 'No', width: 50 },
        { field: 'code', headerName: 'Code', width: 200 },
        { field: 'type', headerName: 'Type', width: 220 },
        {
            field: 'action', headerName: '', width: 100, type: 'actions', getActions: (params) => [
                <GridActionsCellItem icon={<EditIcon />} label="Edit" onClick={() => {
                    const curItem = rbdStore.getRbdItem(params.row.id);
                    if (curItem) rbdStore.setEditRbdItem(curItem);
                }} />,
                <GridActionsCellItem disabled={rbdStore.getRbdItem(params.row.id)?.isGrouped} icon={<DeleteIcon />} label="Delete" onClick={() => {
                    dialogStore.open({
                        title: "Remove data?",
                        description: `${params.row.no}. ${params.row.code}`,
                        closeText: "Cancel",
                        action: async () => {
                            let curItem = rbdStore.getRbdItem(params.row.id);
                            if (curItem) rbdStore.deleteRbdItem(curItem);
                        },
                        actionText: "Remove"
                    })
                }} />
            ]
        }
    ];

    return (
        <DataGrid
            rows={rbdStore.rbdItemRows}
            columns={columns}
            rowHeight={36}
            hideFooter
            loading={rbdStore.loadingTable}
        />
    );
}

export default observer(RBDSettingTable);